module.exports = __webpack_public_path__ + "img/ic_linkedin.ff142fe5.png";